/**
 * Unified SCORM content type — schema, types, defaults.
 * Supports both SCORM 1.2 and SCORM 2004 packages.
 * Version is auto-detected from the uploaded package manifest.
 */

export interface ScormData {
    /** Content title (auto-filled from manifest, user-editable). */
    title?: string;
    /** Content description. */
    description?: string;
    /** SCORM version detected from manifest: 'scorm-12' or 'scorm-2004'. */
    scormVersion?: string;
    /** SCORM package ID (set after upload). */
    packageId?: string;
    /** Original zip filename. */
    packageFileName?: string;
    /** File size in bytes. */
    packageFileSize?: number;
    /** Package base URL for file serving. */
    packageUrl?: string;
    /** Launch URL relative to packageUrl. */
    launchUrl?: string;
    /** Parsed manifest data. */
    manifest?: Record<string, unknown>;
    /** Default organization ID. */
    defaultOrganizationId?: string;
}

export type ScormAnswer = {
    completed: boolean;
    scoreRaw?: number | null;
    /** SCORM 2004 only: scaled score (-1.0 to 1.0). */
    scoreScaled?: number | null;
    completionStatus?: string;
    /** SCORM 2004 only: success status. */
    successStatus?: string;
    totalTime?: string;
};

export const defaultScormData: ScormData = {
    title: undefined,
    description: undefined,
    scormVersion: undefined,
    packageId: undefined,
    packageFileName: undefined,
    packageFileSize: undefined,
    packageUrl: undefined,
    launchUrl: undefined,
    manifest: undefined,
    defaultOrganizationId: undefined,
};
